<!--被执行人-->
<template>
  <div class="executor-container">
    <header-index/>
    <div class="executor-content">
      <div class="executor-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item>被执行人</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="executor-top">
        <p class="executor-title">查询被执行人</p>
        <el-input placeholder="请输入企业名称、组织机构代码" v-model="keyword" class="input-with-select" style="width: 45%;"
                  @keyup.enter.native="getExecutorInfo">
          <el-button type="danger" slot="append" @click="getExecutorInfo">查一下</el-button>
        </el-input>
      </div>
      <div class="executor-info">
        <div class="executor-search-menu">
          <span>最新被执行人</span>
          <div>
            <el-select v-model="region" placeholder="请选择" style="width: 170px;margin-right: 20px" clearable>
              <el-option :label="'全国'" :value="''"/>
              <el-option v-for="item in provincialCode" :label="item.name" :value="item.code"/>
            </el-select>
            <el-date-picker v-model="year" value-format="yyyy" type="year" placeholder="年份不限" style="width: 170px"/>
          </div>
        </div>
        <div class="executor-list" v-if="executorInfo.length>0">
          <div v-for="info of executorInfo" class="executor-list-item" @click="executorDetails(info)">
            <p class="executor-small-title">{{ info.companyName }}</p>
            <p>
              <span class="executor-gray">案号：</span>
              <span class="executor-black executor-200">{{ info.caseNumber }}</span>
              <span class="executor-gray">执行标的(元)：</span>
              <span class="executor-black executor-120">{{ info.executedObject }}</span>
              <span class="executor-gray">立案日期：</span>
              <span class="executor-black executor-120">{{ info.filingDate }}</span>
              <span class="executor-gray">执行法院：</span>
              <span class="executor-black">{{ info.courtExecution }}</span>
            </p>
          </div>
        </div>
        <div v-else>
          <el-empty description="暂无内容"/>
        </div>
        <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
              :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <!--被执行人详情-->
    <el-dialog title="被执行人详情" :visible.sync="dialogVisible">
      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item>
          <template slot="label">失信被执行人</template>
          {{ executorDetail.executedName || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">立案日期</template>
          {{ executorDetail.filingDate || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">案号</template>
          {{ executorDetail.caseNumber || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">身份证号码/组织机构代码</template>
          {{ executorDetail.orgCode || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">执行标的</template>
          {{ executorDetail.executedObject+'元' || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">执行法院</template>
          {{ executorDetail.courtExecution || '-' }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import cityJson from "@/static/cityJson.json";
import page from "@/components/page/pages";
import {getExecutorRegion, searchDdExecutedPerson} from '@/api/enterprise_searchApi'
import {getDdExecutedPersonByDetails} from '@/api/enterpriseDetailsApi'
export default {
  name: "executor",
  components: {Hang, Home_footer, HeaderIndex,page},
  data(){
    return{
      keyword: '',
      cid: 0,
      cityList: {},
      year: '',
      region: '',
      cityJson: cityJson,
      provincialCode: [],
      executorInfo:[],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      executorDetail:{},
      dialogVisible:false,
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getExecutorInfo();
      }
    },
    region(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getExecutorInfo();
      }
    },
  },
  methods: {
    /*获取被执行人信息*/
    getExecutorInfo() {
      searchDdExecutedPerson({
        keyword: this.keyword,
        region: this.region || 0,
        year: this.year,
        page: this.tablePage.currentPage,
        request: 'form'
      }).then(res => {
        if (res.code==200){
          this.tablePage.total=parseInt(res.content.total);
          this.executorInfo=res.content.rows;
          console.log(res);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getExecutorInfo();
    },
    /*被执行人地域分组*/
    getRegion(){
      getExecutorRegion().then(res=>{
        if (res.code==200){
          console.log(res.content);
          this.provincialCode=res.content;
        }
      })
    },
    /*被执行人详情*/
    executorDetails(info){
      getDdExecutedPersonByDetails({id:info.id,request:'form'}).then(res=>{
        if (res.code==200){
          console.log(res.content);
          this.executorDetail=res.content;
          this.dialogVisible=true;
        }
      })
    }
  },
  mounted() {
    this.getExecutorInfo();
    this.getRegion();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')){
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name){
          this.cityList = li;
        }
      }
    }
  }
}
</script>
<style scoped>
.executor-container >>> .executor-content .executor-top .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px 0px 0px 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
  border-right: none;
}
.executor-container >>> .executor-content .executor-top input::-webkit-input-placeholder {
  color: #333333;
}
.executor-container >>> .executor-content .executor-top .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}
.executor-container >>> .executor-content .executor-top .el-icon-search {
  font-size: 19px;
}
.executor-container >>> .executor-content .executor-top .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}
.executor-container >>> .executor-content .executor-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}
.executor-container >>> .executor-content .executor-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.executor-container >>> .executor-content .executor-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.executor-container >>> .executor-content .executor-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.executor-container >>> .executor-content .executor-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.executor-container >>> .executor-content .executor-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.executor-container >>> .executor-content .executor-breadcrumb .el-breadcrumb__inner a,
.executor-container >>> .executor-content .executor-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.executor-container >>> .executor-content .executor-info .executor-search-menu input::-webkit-input-placeholder {
  color: #333333;
}
.executor-container >>> .el-descriptions-item__label.is-bordered-label {
  color: #333333;
  background: #D6E9FF;
  width: 150px;
}
.executor-container >>> .el-descriptions .is-bordered .el-descriptions-item__cell {
  border: 1px solid #D0E0F2;
  padding: 12px 10px;
  font-size: 14px;
  color: #333333;
}
.executor-container >>> .el-descriptions__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.executor-container >>> .el-descriptions__title {
  font-size: 16px;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
}
.executor-container >>> .el-descriptions-item__content {
  min-width: 305px;
}
</style>
<style scoped lang="scss">
.executor-container {
  background: #E7E9F5;
  .executor-content {
    .executor-breadcrumb {
      padding: 10px 18%;
      min-width: 76rem;
      background: #E7E9F5;
    }

    .executor-top {
      background: url("~@/assets/img/enterprise/enterprise_search.png") no-repeat;
      height: 300px;
      min-width: 76rem;
      background-size: 100% 100%;
      text-align: center;
      padding: 0px 18%;
      .executor-title {
        color: #ffffff;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 70px 0px 50px;
        font-weight: bold;
      }
    }

    .executor-info {
      margin: 20px 18%;
      background: #FFFFFF;
      padding: 15px 0px;
      min-width: 76rem;
      .executor-search-menu {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E7E9F5;
        align-items: center;
        padding-bottom: 15px;
        padding-left: 20px;
        padding-right: 20px;

        span {
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          color: #333333;
        }
      }

      .executor-list {
        .executor-list-item {
          border-bottom: 1px solid #E7E9F5;
          padding: 20px;

          .executor-small-title {
            font-size: 18px;
            font-family: 'SourceHanSansCN';
            color: #333333;
            padding-bottom: 15px;
          }

          .executor-gray {
            color: #999999;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }

          .executor-black {
            color: #333333;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }
          .executor-120{
            min-width: 120px;
            display: inline-block;
          }
          .executor-200{
            min-width: 200px;
            display: inline-block;
          }
          p {
            margin-block-end: 0px;
            margin-block-start: 0px;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}
</style>